import React from 'react';
import NFTCard from '../../newComponents/NFTCard';
import { CreatePageForm, CreatePageInner, CreatePagePreview, CreatePageWrapper, PageSection, PageSectionContent, PageSectionTitle, PropertySection, PropertySectionItem } from './styled';
import { Formik, Form } from 'formik'
import INFTProperties from '../../models/INFTProperties';
import { INFTCreateFormValues } from '../../models/INFTCreateERC721';
import NFTUpload from '../../components/NFTUpload/NFTUpload';
import { INTFFileUpload } from '../Create/NFTCreateERC721/INTFCreateERC721';
import NFTInput from '../../components/NFTInput/NFTInput';
import { useActiveWeb3React } from '../../../../hooks';
import { shortenAddress } from '../../../../utils';
import { useCalculateMintFee, useGetBaseNFTMintFeePrice, useGetMaxCreatorFeeRate } from '../../../../hooks/useYetiSwapNFTCollection';
import NFTRangeSlider from '../../components/NFTRangeSlider';
import Scrollbar from '../../components/Scrollbar';
import NFTButton from '../../newComponents/NFTButton';
import { NFTProperties, NFTPropertyItem } from '../../newComponents/NFTDetail/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRemove } from '@fortawesome/free-solid-svg-icons';
import { validateExtendUrl, validateFile, validateProperties, validateRoyalties, validateTitle } from '../Create/NFTCreateERC721/NFTCreateERC721Validate';
import { values } from 'lodash';
import { YETISWAP_NFT_COLLECTION_ADDRESS } from '../../../../constants';
import { ChainId } from '@yetiswap/sdk';
import NFTCreateModal from '../../components/NFTCreateModal';
import { Helmet } from 'react-helmet';


const formInitialValues = {
    title: '',
    description: '',
    royalties: 5,
    nftFile: null,
    coverFile: null,
    nftProperties: '',
    externalUrl: ''
}

const initialFormError = {
    title: '',
    royalties: '',
    nftFile: '',
    coverFile: '',
    nftProperties: ''
}

const initialNFTProperties: INFTProperties = {
    key: '',
    value: '',
    show: true,
    isUrl: false
}

const CreatePage = () => {
    const { account, chainId } = useActiveWeb3React();
    const maxCreatorFeeRate = useGetMaxCreatorFeeRate()
    const baseNftMintFeePrice = useGetBaseNFTMintFeePrice()

    const [nftFile, setNFTFile] = React.useState<INTFFileUpload | null>(null);
    const [coverFile, setCoverFile] = React.useState<INTFFileUpload | null>(null);
    const [nftTitle, setNftTitle] = React.useState('');
    const [nftDescription, setNftDescription] = React.useState('');
    const [externalUrl, setExternalUrl] = React.useState('');
    const [royalties, setRoyalties] = React.useState(formInitialValues.royalties);
    const [propertyKey, setPropertyKey] = React.useState<string>();
    const [propertyValue, setPropertyValue] = React.useState<string>();
    const [nftProperties, setNFTProperties] = React.useState<INFTProperties[]>([]);
    const calculateMintFee = useCalculateMintFee(baseNftMintFeePrice, royalties);
    const mintFeeText = calculateMintFee.toSignificant(4) !== '0' ? calculateMintFee.toSignificant(4) + ' YTS' : '';
    const fileType = nftFile ? nftFile.file.type.split('/')[0] : 'image';
    const [formError, setFormErrors] = React.useState<any>(initialFormError);
    const [didMount, setDidMount] = React.useState(false);
    const [createModalIsOpen, setCreateModalIsOpen] = React.useState(false)
    const [nftFormData, setNftFormData] = React.useState<INFTCreateFormValues>(formInitialValues)

    const collectionAddress = chainId
        ? YETISWAP_NFT_COLLECTION_ADDRESS[chainId]
        : YETISWAP_NFT_COLLECTION_ADDRESS[ChainId.BOBA]

    const onSubmit = React.useCallback((values: any) => {
        delete values.propertyKey;
        delete values.propertyValue;
        values.nftProperties = nftProperties;
        values.royalties = +royalties;
        let _isValid = validateForm();

        if (_isValid) {
            setNftFormData(values);
            setCreateModalIsOpen(true);
        }
    }, [nftProperties, nftFile, coverFile, nftTitle, nftDescription, externalUrl, royalties, maxCreatorFeeRate]);

    React.useEffect(() => {
        setDidMount(true);
        return () => {
            setDidMount(false);
        }
    }, []);

    const validateForm = () => {
        let formErrors = {
            ...initialFormError,
            title: validateTitle(nftTitle),
            nftFile: validateFile(nftFile?.file, 'file'),
            coverFile: fileType !== 'image' ? validateFile(coverFile, 'cover') : '',
            royalties: validateRoyalties(royalties, maxCreatorFeeRate),
            nftProperties: validateProperties(nftProperties),
            externalUrl: validateExtendUrl(externalUrl)
        };
        setFormErrors(formErrors);

        if (Object.values(formErrors).every(e => !e)) {
            return true;
        } else {
            return false;
        }
    }

    React.useEffect(() => {
        if (didMount) {
            setFormErrors({ ...formError, title: validateTitle(nftTitle) });
        }
    }, [nftTitle]);

    React.useEffect(() => {
        if (didMount) {
            setFormErrors({ ...formError, nftFile: validateFile(nftFile?.file, 'file') });
        }
    }, [nftFile]);

    React.useEffect(() => {
        if (didMount) {
            setFormErrors({ ...formError, coverFile: fileType !== 'image' ? validateFile(coverFile, 'cover') : '' });
        }
    }, [coverFile]);

    React.useEffect(() => {
        if (didMount) {
            setFormErrors({ ...formError, royalties: validateRoyalties(royalties, maxCreatorFeeRate) });
        }
    }, [royalties, maxCreatorFeeRate]);

    return (
        <CreatePageWrapper>
            <Helmet>
                <title>{"Create NFT - YetiSwap NFT Marketplace"}</title>
            </Helmet>
            <Scrollbar>
                <CreatePageInner>
                    <CreatePagePreview>
                        <PageSection>
                            <PageSectionTitle>Preview</PageSectionTitle>
                            <PageSectionContent>
                                <NFTCard
                                    saleToken={"0x0000000000000000000000000000000000000000"}
                                    tokenContract="0x0000000004bFeF9b1A67aA4E15943824996c9761"
                                    price={"?"}
                                    title={nftTitle || "Awesome NFT"}
                                    seller={account ? shortenAddress(account, 3) : "0xcDf..1fd"}
                                    tokenId="441">
                                    {nftFile && <img src={URL.createObjectURL(nftFile.file)} alt="" />}
                                </NFTCard>
                            </PageSectionContent>
                        </PageSection>
                    </CreatePagePreview>
                    <CreatePageForm>
                        <Formik onSubmit={(values: any) => onSubmit(values)} initialValues={formInitialValues}>
                            {({ submitForm }) => (
                                <Form encType="multipart/form-data" autoComplete="off">
                                    <PageSection>
                                        <PageSectionTitle>Upload File</PageSectionTitle>
                                        <PageSectionContent>
                                            <NFTUpload
                                                accept="image/png,image/jpeg,image/gif,image/webp,video/mp4,video/webm,audio/mp3,audio/webm,audio/mpeg"
                                                description="PNG, GIF, WEBP, MP4 or MP3. Max 10mb."
                                                id="nftFile"
                                                name="nftFile"
                                                setFieldValue={(value: INTFFileUpload | null) => {
                                                    setNFTFile(value)
                                                }}
                                                value={nftFile}
                                                removeFile={() => setNFTFile(null)}
                                                errorMessage={formError.nftFile}
                                            />
                                        </PageSectionContent>
                                    </PageSection>
                                    {fileType !== 'image' &&
                                        <PageSection>
                                            <PageSectionTitle>Upload Cover</PageSectionTitle>
                                            <PageSectionContent>
                                                <NFTUpload
                                                    accept="image/png,image/jpeg,image/gif,image/webp"
                                                    description="JPG, PNG, GIF or WEBP. Max 10mb."
                                                    id="coverImage"
                                                    name="coverImage"
                                                    //label="Upload cover"
                                                    setFieldValue={(value: INTFFileUpload | null) => setCoverFile(value)}
                                                    value={coverFile}
                                                    errorMessage={formError.coverFile}
                                                    removeFile={() => setCoverFile(null)}
                                                />
                                            </PageSectionContent>
                                        </PageSection>
                                    }
                                    <PageSection>
                                        <PageSectionTitle>Title</PageSectionTitle>
                                        <PageSectionContent>
                                            <NFTInput
                                                id="title"
                                                name="title"
                                                placeholder={'e. g. "Redeemable T-Shirt with logo"'}
                                                errorMessage={formError.title}
                                                onKeyUp={(value) => setNftTitle(value)}
                                            />
                                        </PageSectionContent>
                                    </PageSection>
                                    <PageSection>
                                        <PageSectionTitle>Description (Optional)</PageSectionTitle>
                                        <PageSectionContent>
                                            <NFTInput
                                                id="description"
                                                name="description"
                                                //label="Description"
                                                optional={true}
                                                placeholder={'e. g. "After purchasing you will be able to get the real T-Shirt"'}
                                                description="With preserved line-breaks"
                                                onKeyUp={(value) => setNftDescription(value)}
                                            />
                                        </PageSectionContent>
                                    </PageSection>
                                    <PageSection>
                                        <PageSectionTitle>External Url (Optional)</PageSectionTitle>
                                        <PageSectionContent>
                                            <NFTInput
                                                id="externalUrl"
                                                name="externalUrl"
                                                placeholder={'e. g. "https://yetiswap.app"'}
                                                optional={true}
                                                errorMessage={formError.externalUrl}
                                                onKeyUp={(value) => setExternalUrl(value)}
                                            />
                                        </PageSectionContent>
                                    </PageSection>
                                    <PageSection>
                                        <PageSectionTitle>Royalties</PageSectionTitle>
                                        <PageSectionContent>
                                            <NFTRangeSlider
                                                id="royalties"
                                                name="royalties"
                                                //label="Royalties"
                                                max={maxCreatorFeeRate}
                                                min={0}
                                                placeholder={'e. g. "10%"'}
                                                errorMessage={formError.royalties}
                                                description="e. g.: 5%, 10%, 15%"
                                                onKeyUp={(value) => setRoyalties(value)}
                                                value={royalties}
                                            />
                                        </PageSectionContent>
                                    </PageSection>
                                    <PageSection>
                                        <PageSectionTitle>Properties</PageSectionTitle>
                                        <PageSectionContent>
                                            <PropertySection>
                                                <PropertySectionItem>
                                                    <NFTInput
                                                        key={"keyName-" + nftProperties.length}
                                                        id={"keyName-" + nftProperties.length}
                                                        name="nftKey"
                                                        label={''}
                                                        placeholder="e.g Size"
                                                        onKeyUp={(val: string) => { setPropertyKey(val); }}
                                                    //isValid={!formError.nftProperties}
                                                    />
                                                </PropertySectionItem>
                                                <PropertySectionItem>
                                                    <NFTInput
                                                        key={"keyValue-" + nftProperties.length}
                                                        id={"keyValue" + nftProperties.length}
                                                        name="nftValue"
                                                        label={''}
                                                        placeholder="e.g Medium"
                                                        onKeyUp={(val: string) => setPropertyValue(val)}
                                                    //isValid={!formError.nftProperties}
                                                    />
                                                </PropertySectionItem>
                                                <PropertySectionItem>
                                                    <NFTButton disabled={!propertyKey || !propertyValue} style={{ width: 200, height: 40, flex: 'unset' }} onClick={() => {
                                                        if (propertyKey && propertyValue) {
                                                            setNFTProperties([...nftProperties, { key: propertyKey, value: propertyValue, show: true }])
                                                            setPropertyKey("");
                                                            setPropertyValue("");
                                                        }
                                                    }}>{`Add Property`}</NFTButton>
                                                </PropertySectionItem>
                                            </PropertySection>
                                        </PageSectionContent>
                                    </PageSection>
                                    {!!nftProperties.length &&
                                        <PageSection>
                                            <NFTProperties>
                                                {nftProperties.map((property: any, index: number) => (
                                                    <NFTPropertyItem key={`${property.key}_${index}`} className="removable">
                                                        <span>{property.key}</span>
                                                        <div>{property.value}</div>
                                                        <p className='remove-icon' onClick={() => {
                                                            const newProperties = nftProperties.filter((prop: any) => prop.key !== property.key)
                                                            setNFTProperties(newProperties);
                                                        }}><FontAwesomeIcon icon={faRemove} /></p>
                                                    </NFTPropertyItem>
                                                ))}
                                            </NFTProperties>
                                        </PageSection>
                                    }
                                    {account && mintFeeText && <span>{`You will pay ${mintFeeText} for royalties fee`}</span>}
                                    {!account && <p>{`You need to connect your wallet to create a new NFT`}</p>}
                                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1rem' }}>
                                        <NFTButton title={account ? "Create NFT" : "Connect your wallet to create NFT"} disabled={!account} style={{ width: 300, height: 60, flex: 'unset' }} onClick={() => {
                                            submitForm();
                                        }}>{`Create NFT ${mintFeeText ? "( " + mintFeeText + " )" : ""}`}</NFTButton>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </CreatePageForm>
                </CreatePageInner>
            </Scrollbar>
            {createModalIsOpen && <NFTCreateModal
                isOpen={createModalIsOpen}
                onDismiss={() => { setCreateModalIsOpen(false); }}
                nftFile={nftFile?.file}
                coverFile={coverFile?.file}
                nftFormData={nftFormData}
                properties={nftProperties}
                mintFee={calculateMintFee}
                collectionAddress={collectionAddress}
            />}
        </CreatePageWrapper >
    )
}

export default CreatePage;

